import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React from "react";

export default function Icon({ icon }) {
  library.add(icon);
  return <FontAwesomeIcon icon={icon} />;
}
